module.exports = __webpack_public_path__ + "img/logo.1021e632.png";